import store from '@/store';
import Vue from 'vue';

export const openSuccessModal = ({ content, title, isClosable = true }) => {
  store.commit('helper/openSuccessModal', { content, isClosable, title });
};

export const closeSuccessModal = () => {
  store.commit('helper/closeSuccessModal');
};

export const openErrorModal = ({ content, title, isClosable = true }) => {
  store.commit('helper/openErrorModal', { content, isClosable, title });
};

export const closeErrorModal = () => {
  store.commit('helper/closeErrorModal');
};

const modal = {
  openSuccessModal,
  closeSuccessModal,
  openErrorModal,
  closeErrorModal,
};

Vue.prototype.$modal = modal;
